import { BlockCard } from "src/modules/worksheet/components/WorksheetEditor/components/Editor";

const renderCard = (props: any) => {
    return <BlockCard {...props}>Color Combine Block</BlockCard>;
};

export default renderCard;
